import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

interface StatusIndicatorProps {
  color: string;
  glow?: boolean;
}

const StatusIndicator = (props: StatusIndicatorProps) => {
  return <Box color={props.color} sx={{
    width: 12,
    height: 12,
    borderRadius: '50%',
    backgroundColor: `var(--color-${props.color})`,
    boxShadow: `0 0 ${props.glow ? "6px" : "0"} var(--color-${props.color})`,
  }} />;
};

export default StatusIndicator;